import FormattedMessage from '../../../helpers/FormattedMessage'
import { Button } from 'src/components/Button'
import styles from './ShopPage.module.scss'
import { CapType, schoolCaps } from '../../../setups/setups'
import {useEffect, useState } from 'react'
import { CustomInput } from '../../../components/CustomInput'

interface IProps {
  nextStep: () => void
}

export const ShopPage = ({ nextStep }: IProps) => {
  const [savedItems] = useState(window.localStorage.getItem('School-savedItems') || '')
  const [isError, setIsError] = useState(false)
  var count = 0;

  useEffect(() => {
    if (savedItems) {
      //window.localStorage.setItem('School-savedItems', JSON.stringify(data))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setCap = (cap: string, size: string, num: number) => {
    schoolCaps[cap].sizes[size] = num;
    setIsError(false)
  }

  const next = () => {
    const data: CapType = {};
    setIsError(false)
    var isReady = false;
    Object.keys(schoolCaps).forEach(function(cap) {
      Object.keys(schoolCaps[cap].sizes).forEach(function(size) {
        if (schoolCaps[cap].sizes[size] > 0) {
          if (!data[cap]) {
            data[cap] = {
              title: schoolCaps[cap].title,
              sizes: {}
            }
          }
          data[cap].sizes[size] = schoolCaps[cap].sizes[size];
          isReady = true;
        }
      });  
    });

    if (isReady) {
      window.localStorage.setItem('School-savedItems', JSON.stringify(data))
      nextStep()
    } else {
      setIsError(true)
    }
  }

  return (
    <>
      <div className={styles.Wrapper}>
        <div className={styles.TitleWrapper}>
          <h3 className={styles.Title}><FormattedMessage id={`Shop.title`} /></h3>
          <h2 className={styles.SubTitle}><FormattedMessage id={`Shop.subtitle`} /></h2>
          <span className={styles.Desc}><FormattedMessage id={`Shop.desc`} /></span>
        </div>
        <div className={styles.ItemsWrapper}>
          {Object.keys(schoolCaps).map((item) => (
            <div className={`${styles.ItemWrapper} ${count++ === 0 && styles.FirstItem}`} key={item}>
              <img src={schoolCaps[item].img} alt={item} />
              <h3>
                <FormattedMessage id={`CapType.${item}`} defaultMessage={schoolCaps[item].title} />
              </h3>

              <div className={styles.SizeWrapper}>
                <div className={styles.SizeItem}>
                  <span className={styles.SizeItemName}><FormattedMessage id={`Shop.column1`} /></span>
                  <span className={styles.SizeItemName}><FormattedMessage id={`Shop.column2`} /></span>
                </div>  
                {Object.keys(schoolCaps[item].sizes).map((size) => (
                    <div key={item + "-div-" + size} className={styles.SizeItem}>
                      <span className={styles.SizeItemSize}>{size}</span>
                      <CustomInput
                          value={schoolCaps[item].sizes[size] + ""}
                          onChange={setCap}
                          title={size}
                          placeholder="Kpl"
                          typedata={item}
                      />
                    </div>
                ))}

              </div>
            </div>
          ))}
        </div>
        {isError && <span className={styles.ErrorWrapper}><FormattedMessage id="Shop.error"/></span>}
        <div className={styles.ButtonWrapper}>
          <Button
            center
            onClick={next}
            buttonColor={false}
            buttonDescription="Shop.orderButton"
            classWidth={true}
          />
        </div>
      </div>
    </>
  )
}